export default "__VITE_ASSET__DUYB1LBa__"